// The Source of Funds step on the Golden Rule strip (MatterIntakeDetail).
//
// BM-H3703 (5 Oct 2026): source of funds applies on residential purchases and
// commercial acquisitions. Since 3 Nov 2026 (Vanessa) it no longer gates the
// client care letter; it gates Pre-Exchange approval (backend hub/checklist.py). On BL.RM.001.1553 the
// CCL refused "No source of funds has been recorded for this matter" while the
// strip had no step for it at all. The backend says whether it applies
// (pipelineStatus.pips.source_of_funds); the step is drawn only when it does.
// A failed read is amber "Could not check", never complete.
//
// Returns null when no step is to be drawn, otherwise
// { status: "complete" | "in_progress" | "pending", label }.
export function sofStripStep(pips) {
  const sof = pips?.source_of_funds;
  if (!sof || !sof.required) return null;
  if (sof.done) return { status: "complete", label: "Recorded" };
  if (sof.unavailable) return { status: "in_progress", label: "Could not check" };
  if (sof.captured) return { status: "in_progress", label: "Incomplete" };
  return { status: "pending", label: "Not recorded" };
}
